
import React from 'react';
import { Music, Calendar, Video, Users } from 'lucide-react';

const Features = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-piano-black">
            Personlig & professionel klaverundervisning tilpasset netop dig
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Oplev en dedikeret og inspirerende tilgang til klaverundervisning, der er skræddersyet til dine behov og musikalske drømme.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-md text-center transition-transform hover:translate-y-[-5px]">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-piano-gold/10 text-piano-gold mb-6">
              <Music className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-serif font-semibold mb-4">Erfaren pianist</h3>
            <p className="text-gray-600">
              Undervisning af høj kvalitet fra en pianist uddannet fra Rytmisk Musikkonservatorium med solid erfaring.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-md text-center transition-transform hover:translate-y-[-5px]">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-piano-gold/10 text-piano-gold mb-6">
              <Users className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-serif font-semibold mb-4">Alle niveauer</h3>
            <p className="text-gray-600">
              Undervisning tilpasset din erfaring og dine mål - fra nybegyndere til øvede pianister.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-md text-center transition-transform hover:translate-y-[-5px]">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-piano-gold/10 text-piano-gold mb-6">
              <Video className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-serif font-semibold mb-4">Online undervisning</h3>
            <p className="text-gray-600">
              Fleksibel online undervisning der passer ind i din hverdag, uanset hvor du befinder dig.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-md text-center transition-transform hover:translate-y-[-5px]">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-piano-gold/10 text-piano-gold mb-6">
              <Calendar className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-serif font-semibold mb-4">Fleksibel booking</h3>
            <p className="text-gray-600">
              Vælg mellem enkelttimer eller faste tider for en hel sæson, alt efter dine behov.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
